export const cleanSelection = () => {
  const selection = window.getSelection();
  if (selection) {
    selection.removeAllRanges();
  }
};

export const pickTableDataFrom = (html: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const table = doc.querySelector('table');

  if (table) {
    const rows: string[][] = [];
    table.querySelectorAll('tr').forEach(tr => {
      const rowData: string[] = [];
      tr.querySelectorAll('td,th').forEach(cell => {
        // Replace new lines with carriage returns to preserve line breaks in cells
        rowData.push(cell.textContent?.trim().replace(/\n/g, '\r') ?? '');
      });
      if (rowData.length > 0) {
        rows.push(rowData);
      }
    });
    if (rows.length > 0) {
      return rows.map(row => row.join('\t')).join('\n');
    }
  }
  return null;
};

/**
 * 从剪切板项目中提取HTML内容
 */
export const getClipboardHtml = async (): Promise<string | null> => {
  const items = await navigator.clipboard.read();
  for (const item of items) {
    if (item.types.includes('text/html')) {
      try {
        const blob = await item.getType('text/html');
        return await blob.text();
      } catch (error) {
        console.warn('Failed to extract HTML from clipboard item:', error);
      }
    }
  }
  return null;
};

/**
 * 从剪切板获取内容：优先获取HTML，如果没有HTML则使用纯文本兜底
 * @param preferPlainText 是否优先使用纯文本（忽略HTML内容）
 * @returns 剪切板内容字符串
 */
export const getClipboardText = async (): Promise<string> => {
  try {
    const plainText = await navigator.clipboard.readText();
    return plainText;
  } catch (error) {
    console.warn('Failed to read clipboard content:', error);
    // 如果读取失败，返回空字符串
    return '';
  }
};
